import { render, staticRenderFns } from "./scroll-pane.vue?vue&type=template&id=112369e7&"
import script from "./scroll-pane.vue?vue&type=script&lang=js&"
export * from "./scroll-pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('112369e7')) {
      api.createRecord('112369e7', component.options)
    } else {
      api.reload('112369e7', component.options)
    }
    module.hot.accept("./scroll-pane.vue?vue&type=template&id=112369e7&", function () {
      api.rerender('112369e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabs/scroll-pane.vue"
export default component.exports